/**
 * mzp-gallery.js
 * Handles thumbnail clicks, updates the main MagicZoom image,
 * and manages prev/next slide arrows.
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var blocks = document.querySelectorAll('.mzp-block');

    blocks.forEach(function (block) {
      var productId = block.dataset.productId;
      var zoomEl    = block.querySelector('.MagicZoomPlus');
      var thumbs    = block.querySelectorAll('.mz-thumb');
      var prevBtn   = block.querySelector('.MagicToolboxSlides-arrow.magic-prev');
      var nextBtn   = block.querySelector('.MagicToolboxSlides-arrow.magic-next');

      if (!zoomEl || !thumbs.length) return;

      var currentIndex = 0;
      var thumbArray   = Array.prototype.slice.call(thumbs);

      /* ── activate a thumb by index ── */
      var slidesEl = block.querySelector('.MagicToolboxSlides');

      function activate(index) {
        if (index < 0 || index >= thumbArray.length) return;

        var thumb = thumbArray[index];

        var zoomSrc  = thumb.getAttribute('href');
        var imageSrc = thumb.dataset.image || zoomSrc;

        zoomEl.setAttribute('href', zoomSrc);

        var mainImg = zoomEl.querySelector('img');
        if (mainImg) {
          mainImg.setAttribute('src', imageSrc);
          mainImg.setAttribute('srcset', zoomSrc + ' 2x');
        }

        /* swap active-magic-selector class */
        thumbArray.forEach(function (t) {
          t.classList.remove('active-magic-selector');
        });
        thumb.classList.add('active-magic-selector');

        /* animation */
        if (slidesEl) {
          slidesEl.classList.remove('mzp-slide-anim');
          void slidesEl.offsetWidth;
          slidesEl.classList.add('mzp-slide-anim');
        }

        /* wait for image load then update MagicZoom */
        if (mainImg && window.MagicZoom) {
          if (mainImg.complete) {
            MagicZoom.update(zoomEl.getAttribute('id') || zoomEl);
          } else {
            mainImg.addEventListener('load', function onLoad() {
              mainImg.removeEventListener('load', onLoad);
              MagicZoom.update(zoomEl.getAttribute('id') || zoomEl);
            });
          }
        }

        currentIndex = index;
      }

      /* ── bind thumb clicks ── */
      thumbArray.forEach(function (thumb, idx) {
        thumb.addEventListener('click', function (e) {
          e.preventDefault();
          activate(idx);

          /* also scroll the MagicScroll carousel to show this thumb */
          var scrollEl = block.querySelector('.MagicScroll');
          if (scrollEl && window.MagicScroll) {
            MagicScroll.goTo(scrollEl.getAttribute('id'), idx);
          }
        });
      });

      /* ── prev / next arrows ── */
      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          activate(currentIndex > 0 ? currentIndex - 1 : thumbArray.length - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          activate(currentIndex < thumbArray.length - 1 ? currentIndex + 1 : 0);
        });
      }

      /* ── autoplay ── */
      if (thumbArray.length > 1) {
        var autoplayDelay = parseInt(block.dataset.autoplayDelay) || 5000;
        var autoplayTimer;

        function startAutoplay() {
          clearInterval(autoplayTimer);
          autoplayTimer = setInterval(function () {
            activate(currentIndex < thumbArray.length - 1 ? currentIndex + 1 : 0);
          }, autoplayDelay);
        }

        function stopAutoplay() {
          clearInterval(autoplayTimer);
        }

        startAutoplay();

        if (slidesEl) {
          slidesEl.addEventListener('mouseenter', stopAutoplay);
          slidesEl.addEventListener('mouseleave', startAutoplay);
        }
      }
    });
  });
})();
